import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import ViewMyAnswer from '../components/ViewMyAnswer';
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';
import { VscCheck,VscRocket } from "react-icons/vsc";

const CategoryProblemMyS = ()=> {
       const navigateto = useNavigate();
       const {categoryURL, categoryTitle, problemCode, problem, category} = useLocation().state;
       const {isMyAnswer, myAnswerList, errMyAns} = ViewMyAnswer({"problemCode": problem.problemCode});
       const [selectedAnswer, setSelectedAnswer] = useState();
       const location = useLocation();

       const splitContent = (sentence) => {
              const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
              const matches = sentence.matchAll(InlineMathRegex);
              let lastIndex = 0;
              const contentArray = [];
              
              for (const match of matches) {
                     const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
                     const restOfContent = sentence.substring(lastIndex, match.index);
              
                     contentArray.push(restOfContent, InlineMathContent);
                     lastIndex = match.index + match[0].length;
              }
              
              if (lastIndex < sentence.length) {
                     contentArray.push(sentence.substring(lastIndex));
              }

              contentArray.push("의 풀이 조회");
              
              return <div>{contentArray}</div>;
       };

       function ProblemLinkC ({LinkTitle, LinkId}) {
              return(
                     <div className="subject-sidebar-4">
                            {LinkId === problemCode
                                   ? <b style ={{color:'red'}}>{LinkTitle} <VscCheck/> <VscRocket/></b>
                                   : <Link to={`/door/category/problem/`} state={{
                                                 "categoryURL": categoryURL,
                                                 "categoryTitle": categoryTitle,
                                                 "problemCode": LinkId
                                          }}>
                                                 {LinkTitle}
                                          </Link>
                            }
                     </div>
              )
       }

       function ProblemLink ({LinkTitle, LinkId}) {
              return(
                     <div className="subject-sidebar-4">
                            <Link to={`/door/category/problem/`} state={{
                                   "categoryURL": categoryURL,
                                   "categoryTitle": categoryTitle,
                                   "problemCode": LinkId
                            }}>
                                   {LinkTitle}
                            </Link>
                     </div>
              )
       }

       if (isMyAnswer === false) {
              return(
                     errMyAns 
                            ? navigateto("/login", {state:{"from": location}}, {replace: true})
                            : <div className="problem">
                                   <p>"문제를 푼 기록이 없습니다."</p>
                                   <button 
                                          className='button'
                                          onClick={() => navigateto(`/door/category/problem/`, {state: {
                                                                      "categoryURL": categoryURL,
                                                                      "categoryTitle": categoryTitle,
                                                                      "problemCode": problemCode
                                                        }})
                                                 }
                                   >
                                          문제로 돌아가기
                                   </button>
                            </div>
              )
       }

       console.log("problem: ", problem);
       console.log("category: ", category);
    
       return(
              <div className="App-full-row-container" key={problem.problemCode}>
                     <div className="left-menu-box-1">
                            <h4 style={{fontWeight:"bolder", color:"orange" ,marginTop:"15px", marginBottom:"15px", marginLeft:"5px"}}>
                                   {categoryTitle}
                            </h4>
                            {
                                   category && category.map(problem => {
                                          return(
                                                 <div key={problem.problemCode}>
                                                        {problem.problemCode === problemCode
                                                               ? <ProblemLinkC LinkTitle={problem.problemTitle && splitContent(problem.problemTitle)} LinkId={problem.problemCode} /> 
                                                               : <ProblemLink LinkTitle={problem.problemTitle && splitContent(problem.problemTitle)} LinkId={problem.problemCode} />
                                                        }
                                                 </div>
                                          )
                                   })
                            }
                     </div>
                     <div className="content-box-1">
                            <div className="problem">
                                   <div>
                                          <div style={{fontSize:24,fontWeight:900, marginTop:"20px", marginBottom:"25px"}}>{splitContent(problem.problemTitle)}</div>
                                          <div>
                                                 <select value={selectedAnswer} style={{height:"36px"}} onChange={(e) => setSelectedAnswer(e.target.value)}>
                                                        <option value>문제를 푼 때를 선택하세요.</option>
                                                        {myAnswerList.map(myAns => {
                                                               return <option value={myAns.answerMark} key={myAns.answerMark}>
                                                                      {myAns.solvingTime.substring(6,10)}년 {myAns.solvingTime.substring(3,5)}월 {myAns.solvingTime.substring(0,2)}일 {myAns.solvingTime.substring(12,17)}
                                                               </option>
                                                        })}
                                                 </select>
                                                 <button 
                                                        className='button' 
                                                        style={{marginLeft:"10px"}}
                                                        onClick={() => selectedAnswer 
                                                               ? navigateto(`/door/category/problem/my/${selectedAnswer}`, {state: {
                                                                      "categoryURL": categoryURL,
                                                                      "categoryTitle": categoryTitle,
                                                                      "problemCode": problemCode,
                                                                      "problem": problem,
                                                                      "category": category,
                                                                      "myAnswerList": myAnswerList
                                                               }})
                                                               : alert("문제 풀이 시간을 선택하세요.")
                                                        }
                                                 >
                                                        풀이 보기
                                                 </button>
                                          </div>
                                   </div>
                                   <br/>
                            </div>
                     </div>
              </div>
       );
};

export default CategoryProblemMyS;